import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { User } from 'oidc-client-ts';




@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    currentUser: User;

    constructor(
        private authenticationService: AuthenticationService
    ) {

    }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available

        this.currentUser = this.authenticationService.getOIDCUser();

        if (this.currentUser && this.currentUser.access_token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `${this.currentUser.token_type} ${this.currentUser.access_token}`//`Bearer ${currentUser.token}`,
                }
            });
        }

        return next.handle(request);
    }
}